import { FC } from 'react';
// import { useNavigate } from 'react-router';
/* import { useAppState } from 'stores';
import { isTokenExpired } from '../utils/general'; */

interface PrivateRouteProps {
  element: JSX.Element
}

const PrivateRoute: FC<PrivateRouteProps> = ({ element }) => {
  // const navigate = useNavigate();
  // const { logged, currentUser } = useAppState((state) => state.user);
  // const token = sessionStorage.getItem('token');

  /* useEffect(() => {
    if (!logged || isTokenExpired(currentUser?.exp || 0) || !token) {
      navigate('/login');
    }
  }, [logged, currentUser, token]); */

  return element;
};

export default PrivateRoute;
